import { slugifyAnchorId } from "@/utils/anchorId";

const BOOK_DEMO_ANCHOR = "book-demo";
const BOOK_DEMO_SCHEDULER_ANCHOR = "book-demo-scheduler";

export type FindScrollTargetOptions = {
  preferScheduler?: boolean;
};

/** Locates the DOM element to scroll to for a given anchor id. */
export function findScrollTargetElement(
  anchorId: string,
  options?: FindScrollTargetOptions,
): Element | null {
  const normalizedId = slugifyAnchorId(anchorId);
  if (!normalizedId || typeof document === "undefined") {
    return null;
  }

  if (options?.preferScheduler && normalizedId === BOOK_DEMO_ANCHOR) {
    const scheduler = document.getElementById(BOOK_DEMO_SCHEDULER_ANCHOR);
    if (scheduler) {
      return scheduler;
    }
  }

  return document.getElementById(normalizedId);
}
